import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customer: {
    totalCount: 0,
    totalRemainingTransactionAmount: 0,
    newCustomer: 0,
  },
  sales: {
    totalTransactionAmount: 0,
    totalCount: 0,
    totalRemainingTransactionAmount: 0,
  },
  products: {
    productsCount: 0,
    sumOfAll: 0,
    totalDormantGoods: 0,
    totalDormantPrice: 0,
    totalLowStock: 0,
    totalPurchasePrice: 0,
  },
  purchases: {
    totalTransactionAmount: 0,
    totalCount: 0,
    totalRemainingTransactionAmount: 0,
    pendingOrdersCount: 0,
  },
  return: {
    totalReturnAmount: 0,
    totalCount: 0,
  },
  subscription: {
    totalSubscribedCustomers: 0,
    totalSubscribedProducts: 0,
  },
  tasks: [],
  isLoading: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setStates(state, action) {
      const {
        customersStats,
        productStats,
        purchanseStats,
        sellStats,
        returnStats,
        subscription,
      } = action.payload;
      state.customer = customersStats ? customersStats : state.customer;
      state.products = productStats ? productStats : state?.products;
      state.purchases = purchanseStats ? purchanseStats : state.purchases;
      state.sales = sellStats ? sellStats : state.sales;
      state.return = returnStats ? returnStats : state.return;
      state.subscription = subscription ? subscription : state.subscription;
      state.isLoading = false;
    },
    setTasks(state, action) {
      state.tasks = action.payload || [];
    },
    setDashboardIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const { setStates, setTasks, setDashboardIsLoading } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
